module.exports = __webpack_public_path__ + "fonts/Pretendard-Black.21523cb4.woff";